const apiUrl = process.env.REACT_APP_API_URL;

export async function AssignShopItemToUser(userId: string | number, itemId: string | number) {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/usuaris/${userId}/items/${itemId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        return response.ok;
    } catch (e) {
        console.error("Error assigning shop item to user", e);
        return false;
    }
}

export async function RemoveShopUserItem(instanceId: string | number, userId?: string | number) {
    try {
        // Usa el endpoint consolidado POST /jutge/shop/consume
        const response = await fetch(`${apiUrl}:8061/jutge/shop/consume`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                userId: String(userId || "0"),
                objectId: String(instanceId)
            })
        });
        return response.ok;
    } catch (e) {
        console.error("Error removing shop item", e);
        return false;
    }
}

export async function AssignJavamonToUser(userId: string | number, javamonId: string | number) {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/usuaris/${userId}/javamons/${javamonId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        return response.ok;
    } catch (e) {
        console.error("Error assigning javamon to user", e);
        return false;
    }
}

export async function RemoveJavamonFromUser(userId: string | number, instanceId: string | number) {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/usuaris/${userId}/javamons/instance/${instanceId}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' }
        });
        return response.ok;
    } catch (e) {
        console.error("Error removing javamon from user", e);
        return false;
    }
}

export async function AdjustUserPoints(userId: string | number, points: number, descripcio: string, tipo?: string) {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/usuaris/${userId}/points/adjust`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ points, descripcio, tipo })
        });
        return response.ok;
    } catch (e) {
        console.error("Error adjusting points for user", e);
        return false;
    }
}
